import { BoxPlotFilled, DeleteFilled } from '@ant-design/icons'
import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Button, Col, Popconfirm, Row } from 'antd'
import React, { useState } from 'react'

import { handleRemove } from './helpers'

export function BulkChangeBar({ selectedRows, setIsBulkChangeVisible, removeMutation, gridAPIRef, canEdit }) {
  const [loading, setLoading] = useState()
  const onFinish = () => {
    gridAPIRef?.current?.deselectAll()
    setLoading(false)
    setIsBulkChangeVisible(false)
  }
  if (selectedRows.length > 0) {
    return (
      <Horizontal bg='primary' className='p-3'>
        <Col className='title vertical-flex-center px-3' span={16} align='left'>
          <Texto className='tank-override-count-text'>
            <b>
              {selectedRows.length} tank{selectedRows.length > 1 ? 's' : ''} selected to override.
            </b>{' '}
            You can bulk remove the transitions - or bulk transition tanks.
          </Texto>
        </Col>

        <Col span={8} className='flex items-center h-100 py-3 justify-end'>
          <div className='tank-override-button'>
            <Popconfirm
              title='Are you sure you want to delete all the selected transitions?'
              onConfirm={(e) => {
                setLoading(true)
                handleRemove(selectedRows, removeMutation, onFinish)
              }}
              okText='Yes'
              cancelText='No'
            >
              <GraviButton
                disabled={!selectedRows?.some((tank) => tank.has_transition)}
                className='mr-3'
                loading={loading}
                error
                appearance='solid'
                icon={<DeleteFilled />}
                buttonText='Remove Transitions'
              />
            </Popconfirm>
            <GraviButton
              theme2
              buttonText='Schedule Transition'
              onClick={() => setIsBulkChangeVisible(true)}
              className='mr-3 bright-theme-2'
              icon={<BoxPlotFilled />}
            />
          </div>
        </Col>
      </Horizontal>
    )
  }
  return (
    <div className='bg-3 p-4'>
      {canEdit && (
        <Texto category='h6' weight='bold' appearance='secondary'>
          <BoxPlotFilled className='pr-2' /> Select tank(s) to add a transition.
        </Texto>
      )}
    </div>
  )
}
